type Props = {
  currContactAddresses: any
}

const FilterContactHeader = (props: Props) => {
  const { currContactAddresses } = props

  return (
    <div className="text-small">
      <span className="me-1">
        {currContactAddresses && Object.keys(currContactAddresses).length}
      </span>
      <span>件の検索結果</span>
    </div>
  )
}

export default FilterContactHeader
